/**
 * Service d'envoi d'emails pour les identifiants de connexion
 */

import { getCompanyInfo } from './companyInfoService';
import { db, functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

/**
 * Configuration email (récupérée depuis settings/general)
 */
const getEmailConfig = async () => {
    try {
        const companyInfo = await getCompanyInfo(db);

        return {
            from: {
                email: companyInfo.emailFrom || companyInfo.email || 'noreply@omadservices.com',
                name: companyInfo.emailFromName || companyInfo.denominationSociale || 'OMAD SERVICES'
            }
        };
    } catch (error) {
        console.error('Erreur récupération config email:', error);
        return {
            from: {
                email: 'noreply@omadservices.com',
                name: 'OMAD SERVICES'
            }
        };
    }
};

/**
 * Génère le template HTML pour l'email d'accès
 */
const genererTemplateAcces = (clientName, email, password, loginUrl, companyInfo) => {
    return `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Vos identifiants d'accès - ${companyInfo.denominationSociale}</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            background-color: #f8fafc;
            margin: 0;
            padding: 0;
        }

        .email-container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        }

        .email-header {
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            padding: 30px;
            text-align: center;
        }

        .company-logo {
            max-width: 120px;
            max-height: 60px;
            margin-bottom: 15px;
        }

        .company-name {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 5px;
        }

        .email-content {
            padding: 30px;
        }

        .greeting {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
            color: #1f2937;
        }

        .message {
            font-size: 15px;
            line-height: 1.7;
            color: #4b5563;
            margin-bottom: 25px;
        }

        .credentials-card {
            background: #f0f9ff;
            border: 2px solid #3b82f6;
            border-radius: 8px;
            padding: 25px;
            margin: 20px 0;
            text-align: center;
        }

        .credentials-title {
            font-weight: bold;
            color: #1e40af;
            margin-bottom: 15px;
            font-size: 16px;
        }

        .credential-item {
            margin-bottom: 10px;
            font-size: 15px;
        }

        .credential-label {
            color: #64748b;
            font-size: 13px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .credential-value {
            color: #0f172a;
            font-weight: bold;
            font-family: monospace;
            font-size: 16px;
            background: white;
            padding: 5px 10px;
            border-radius: 4px;
            border: 1px solid #e2e8f0;
            display: inline-block;
            margin-top: 4px;
        }

        .btn {
            display: inline-block;
            padding: 14px 32px;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white !important;
            text-decoration: none;
            border-radius: 6px;
            font-weight: 600;
            font-size: 15px;
            margin: 20px 0;
            transition: all 0.3s ease;
        }

        .btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
        }

        /* Styles de base pour compatibilité maximale */
        .btn {
            display: inline-block;
            padding: 14px 32px;
            background-color: #2563eb;
            color: #ffffff !important;
            text-decoration: none;
            border-radius: 6px;
            font-weight: 600;
            font-size: 15px;
            margin: 20px 0;
            border: 1px solid #1d4ed8;
        }
        .btn span {
            color: #ffffff !important;
        }
    </style>
</head>
<body>
    <div class="email-container">
        <div class="email-header">
            ${companyInfo.logoUrl ? `<img src="${companyInfo.logoUrl}" alt="${companyInfo.denominationSociale}" class="company-logo" width="250" style="width: 250px; max-width: 250px; height: auto;">` : ''}
            <div class="company-name">${companyInfo.denominationSociale}</div>
            <div>Espace Bénéficiaire</div>
        </div>

        <div class="email-content">
            <div class="greeting">
                Bonjour ${clientName},
            </div>

            <div class="message">
                Nous avons le plaisir de vous transmettre vos identifiants personnels pour accéder à votre espace bénéficiaire sécurisé.
                Cet espace vous permet de consulter votre planning, vos documents et de suivre nos prestations.
            </div>

            <div class="credentials-card">
                <div class="credentials-title">🔐 Vos identifiants de connexion</div>
                
                <div class="credential-item">
                    <div class="credential-label">Identifiant (Email)</div>
                    <div class="credential-value">${email}</div>
                </div>

                ${password ? `
                <div class="credential-item">
                    <div class="credential-label">Mot de passe provisoire</div>
                    <div class="credential-value">${password}</div>
                </div>
                ` : ''}

                <a href="${loginUrl}" class="btn"><span>Accéder à mon espace</span></a>
                
                <div style="font-size: 13px; color: #64748b; margin-top: 15px; word-break: break-all;">
                    Ou copiez ce lien: <br>
                    <a href="${loginUrl}" style="color: #3b82f6; text-decoration: none;">${loginUrl}</a>
                </div>
            </div>

            <div class="security-notice">
                <strong>🔒 Sécurité :</strong> Pour votre sécurité, nous vous recommandons de modifier ce mot de passe dès votre première connexion.
            </div>

            <div class="message">
                Si vous rencontrez des difficultés pour vous connecter, n'hésitez pas à nous contacter.
            </div>
        </div>

        <div class="email-footer">
            <strong>${companyInfo.denominationSociale}</strong><br>
            ${companyInfo.telephone ? `Tél : ${companyInfo.telephone}` : ''}
            ${companyInfo.email ? ` • Email : ${companyInfo.email}` : ''}
        </div>
    </div>
</body>
</html>
    `;
};

/**
 * Envoie les identifiants d'accès par email
 * 
 * @param {Object} client - Données du client
 * @param {string} email - Email de connexion (identifiant)
 * @param {string} password - Mot de passe (optionnel)
 * @returns {Promise<Object>} Résultat de l'envoi
 */
export const sendAccessDetailsEmail = async (client, email, password) => {
    try {
        console.log('📧 Envoi email accès à', email);

        // Récupérer les infos de la société
        const companyInfo = await getCompanyInfo(db);

        // Récupérer la config email
        const emailConfig = await getEmailConfig();

        // URL de connexion: Utiliser celle des paramètres si définie, sinon l'origine actuelle + fallback
        let loginUrl = companyInfo.clientPortalUrl;

        if (!loginUrl) {
            // Fallback sur l'origine actuelle si on est côté client, sinon une valeur par défaut
            const origin = typeof window !== 'undefined' ? window.location.origin : 'https://omadservices.agentime.fr';
            loginUrl = `${origin}/client-login`;
        } else {
            // S'assurer que l'URL ne termine pas par un slash pour concaténer proprement si nécessaire
            // Note: ici on assume que l'URL configurée pointe directement vers la page de login ou la racine
            // Si c'est la racine, on pourrait vouloir ajouter /client-login, mais laissons l'utilisateur configurer l'URL complète pour plus de flexibilité
        }

        const clientName = `${client.firstName} ${client.lastName}`;

        // Générer le HTML
        const htmlContent = genererTemplateAcces(clientName, email, password, loginUrl, companyInfo);

        // Sujet
        const subject = `Accès à votre espace bénéficiaire - ${companyInfo.denominationSociale}`;

        // Utiliser la fonction cloud existante (générique)
        // On utilise 'sendInvoiceEmail' car c'est le point d'entrée pour l'envoi d'emails via le provider configuré
        const sendEmail = httpsCallable(functions, 'sendInvoiceEmail');

        const result = await sendEmail({
            to: email, // Envoyer à l'adresse de connexion ou l'email perso du client
            subject: subject,
            html: htmlContent,
            text: `Bonjour ${clientName},\n\nVos identifiants :\nEmail: ${email}\n${password ? `Mot de passe: ${password}\n` : ''}\nConnexion: ${loginUrl}`,
            attachments: []
        });

        console.log('✅ Email accès envoyé:', result.data);

        return {
            success: true,
            message: 'Email envoyé avec succès'
        };

    } catch (error) {
        console.error('❌ Erreur envoi email accès:', error);
        throw new Error(`Échec de l'envoi: ${error.message}`);
    }
};

export default {
    sendAccessDetailsEmail
};
